import { render, staticRenderFns } from "./UpdateTimeOff.vue?vue&type=template&id=31b68afc"
import script from "./UpdateTimeOff.vue?vue&type=script&lang=js"
export * from "./UpdateTimeOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports